
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[brandId]",
      function () {
        return require("private-next-pages/brands/[brandId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[brandId]"])
      });
    }
  